import React, { useState, useEffect } from "react";
import { Grid, Button, } from "@material-ui/core";
import { TextField, Box } from "@material-ui/core";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const UpdateForm = ({ dataId, dataLink, dataIcon, id1, dataIDID, itemid }) => {
  const [selectedImage, setSelectedImage] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [formValues, setFormValues] = useState({
    link_name: {
      value: ''
    },
    link: {
      value: '',
    },
    car_image: {
      value: '',
    },
  })

  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/contact/getContactByID/${itemid}`, {
        withCredentials: true,
      })
      .then((res) => {
  
        setFormValues({
          link_name: {
            value: res.data.data.link_name
          },
          link: {
            value: res.data.data.link
          },
          car_image: {
            value: res.data.data.icon
          },
        })

      }
      )
  }, [])

  useEffect(() => {

    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);



  const handleChange = (e) => {
    e.persist();
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const bodyFormData = new FormData();
    bodyFormData.append("link_name", e.target.link_name.value);
    bodyFormData.append("link", e.target.link.value);
    if (selectedImage == null) {
      bodyFormData.append("icon", formValues.image.value);
    } else {
      bodyFormData.append("icon", selectedImage);
    }
   

    axios
      .post(`${BaseUrl}/api/contact/update/${itemid}`, bodyFormData, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          sweetalert("تمت علية التعديل بنجاح");
          window.location.reload();
        } else {
          sweetalert("error");
        }

      });
  }


  return (
    <div>
      <form
        className="form-group"
        method="post"
        enctype="multipart/form-data"
        noValidate
        onSubmit={handleSubmit}
      >

        <div className="form-group">
          <Grid container maxWidth="sm" spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="الرجاء ادخال رابط المنصة"
                type="text"
                className="form-control"
                variant="outlined"
                label="رابط الأيقونة"
                name="link"
                value={formValues.link.value}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                type="text"
                className="form-control"
                placeholder="الرجاء ادخال اسم المنصة"
                label="اسم المنصة"
                name="link_name"
                variant="outlined"
                required

                value={formValues.link_name.value}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </div>
        <Grid item md={12} xs={12}>
          <div>
            <input
              accept="image/*"
              type="file"
              id="select-image-car"
              name="car_image"
              style={{ display: "none" }}
              onChange={(e) => setSelectedImage(e.target.files[0])}
            />
            <div className="updateImage">
              <label htmlFor="select-image-car">
                <Button variant="contained" color="primary" component="span">
                  تحميل صورة
                </Button>

              </label>
              {selectedImage == null ? (
                <Box mt={2} textAlign="center">
                  <img src={formValues.car_image.value} height="100px" />
                </Box>
              ) : (
                <Box mt={2} textAlign="center">
                  <img src={imageUrl}
                    value={formValues.car_image.value}
                    alt={selectedImage.name} height="100px" />
                </Box>
              )

              }
            </div>
          </div>
        </Grid>


        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Button
            type="submit"
            variant="contained"
            className="btn-submit"
            color="secondary"
          >
            حفظ
          </Button>
        </Grid>
      </form>
    </div>
  );
};

export default UpdateForm;
